import { render, staticRenderFns } from "./EmEpcTagList.vue?vue&type=template&id=a585faba&scoped=true&"
import script from "./EmEpcTagList.vue?vue&type=script&lang=js&"
export * from "./EmEpcTagList.vue?vue&type=script&lang=js&"
import style0 from "./EmEpcTagList.vue?vue&type=style&index=0&id=a585faba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a585faba",
  null
  
)

export default component.exports